export default __webpack_public_path__ + "d77f61d861fd7e34301ad9f6d171d66c.svg";